import React from 'react';
import { MenuItem } from './Navigation';

interface SubmenuItemProps {
	item: MenuItem;
	keyPrefix: string;
	index: number;
	isMobile?: boolean;
}

const SubmenuItem: React.FC<SubmenuItemProps> = ({ 
	item, 
	keyPrefix, 
	index, 
	isMobile = false 
}) => {
	const containerClass = isMobile 
		? 'c-mobile-navigation__submenu-item'
		: 'c-navigation__submenu-item';
	
	const linkClass = isMobile 
		? 'c-mobile-navigation__submenu-link u-medium-01 u-fw-400'
		: 'c-navigation__submenu-link u-bold-10 u-fw-400';

	const tagClass = 'c-menu-link-tag u-regular-07';

	return (
		<li key={`${keyPrefix}-${index}`} className={containerClass}>
			<a href={item.href} className={linkClass}>
				{isMobile ? (
					<>
						{item.label}
						{item.tag && <span className={tagClass}>{item.tag}</span>}
					</>
				) : (
					<>
						<span className="c-navigation__submenu-link-label">
							{item.label}
						</span>
						{item.tag && <i className={tagClass}>{item.tag}</i>}
					</>
				)}
			</a>
		</li>
	);
};

export default SubmenuItem; 